import { useEffect, useState } from "react";
import Loader from "../../components/loader";
import { useNavigate } from "react-router-dom";
import NoRecord from "../../components/NoRecord";
import PanelLayout from "../../layout/PanelLayout";
import { webPaths } from "../../routes/pageRoutes";
import { useDispatch, useSelector } from "react-redux";
import AssetCard from "../../components/pages/AssetCard";
import useDebounce from "../../components/hooks/useDebounce";
import { fetchHomeAssets } from "../../redux/actions/assetAction";
import { statusValueDefine, tabs } from "../../utils/pip";
import CategoryDropdown from "../../components/CategoryDropdown";

const Home = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [categoryId, setCategoryId] = useState("");
  const [searchFilter, setSearchFilter] = useState("");
  const [showHomeSearch, setShowHomeSearch] = useState(true);
  const debouncedSearch = useDebounce(searchFilter, 500);
  const { isLoading, assetList, assetCategoryList } = useSelector(
    (state) => state.assetReducer,
  );

  const [activeTab, setActiveTab] = useState(tabs[0]?.lable);

  useEffect(() => {
    dispatch(
      fetchHomeAssets({
        search: debouncedSearch || "",
        categoryId: categoryId || "",
      }),
    );
  }, [categoryId, debouncedSearch, dispatch]);

  const handleSearch = () => {
    dispatch(
      fetchHomeAssets({
        search: searchFilter || "",
        categoryId: categoryId || "",
      }),
    );
  };

  useEffect(() => {
    const handleScroll = () => {
      setShowHomeSearch(window.scrollY <= 390);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  if (isLoading) {
    return <Loader />;
  }
  return (
    <PanelLayout
      categoryId={categoryId}
      searchFilter={searchFilter}
      assetCategoryList={assetCategoryList}
      onCategoryChange={setCategoryId}
      onSearchChange={setSearchFilter}
      onSearch={handleSearch}
      onClearSearch={() => setSearchFilter("")}
    >
      <section class="ct_home_banner">
        <div class="container">
          <div class="row align-items-center ">
            <div class="col-xl-7">
              <div class="ct_banner_title">
                <h2 class="ct_switzer_bold  ct_fs_44 ">
                  {statusValueDefine[activeTab]?.title}
                </h2>

                <p
                  class="mb-0 ct_text_clr_4B5563  ct_fs_20 "
                  style={{ maxWidth: "909px" }}
                >
                  {statusValueDefine[activeTab]?.description}
                </p>

                {showHomeSearch && (
                  <div className="ct_search_filter_main">
                    <ul>
                      {tabs?.map((item, ind) => (
                        <li
                          onClick={() => setActiveTab(item?.lable)}
                          className="ct_cursor_pointer"
                        >
                          <button
                            className={activeTab == item?.lable ? "active" : ""}
                          >
                            {item?.svg}
                          </button>
                          <small className="ct_text_4f4f4f opacity-75 mt-2">
                            {item?.lable}
                          </small>
                        </li>
                      ))}
                    </ul>

                    <div class="ct_banner_search_filters">
                      <CategoryDropdown
                        value={categoryId}
                        options={assetCategoryList}
                        onChange={setCategoryId}
                        className="ct_select_w_177 ct_w_100_575"
                        buttonClassName="ct_input border-0"
                        style={{ backgroundColor: "transparent", height: "60px" }}
                      />
                      <div class="position-relative ct_search">
                        <input
                          type="text"
                          class="form-control ct_input"
                          style={{
                            boxShadow: "0px 0px 9px 0px #00000040",
                            height: "60px",
                            paddingRight: "90px",
                          }}
                          placeholder="Search assets"
                          value={searchFilter}
                          onChange={(e) => setSearchFilter(e.target.value)}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              handleSearch();
                            }
                          }}
                        />
                        {/* <i class="fa-solid fa-search ct_input_icon_left"></i> */}
                        <button
                          type="button"
                          className="text-white border-0 rounded bg-danger ct_show_eye px-3 py-2"
                          style={{ right: "10px" }}
                          onClick={() => setSearchFilter("")}
                        >
                          Clear
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="col-xl-5 ps-xl-4 d-none d-xl-block">
              <div className="ct_home_banner_side_img">
                <img src={statusValueDefine[activeTab]?.img} />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="ct_mt_60 ">
        <div class="container">
          {/* Header */}
          <div class="d-flex align-items-center justify-content-between mb-2">
            <div>
              <h5 class="ct_fs_32 ct_fw_600">Browse by Category</h5>
              <p class="mb-0 ct_text_clr_4B5563">
                Explore assets across different categories
              </p>
            </div>
            <a
              onClick={(e) => {
                e.preventDefault();
                navigate(webPaths?.BrowseCategory, {
                  state: { assetCategoryList },
                });
              }}
              class="ct_text_clr_4B5563 ct_white_nowrap ct_fw_600"
            >
              View More <i class="fa-solid fa-angle-right ms-1"></i>
            </a>
          </div>

          {/* GRID */}
          <div class="category-grid ct_mt_30">
            {assetCategoryList?.length > 0 ? (
              <>
                {assetCategoryList?.slice(0, 4)?.map((item, index) => (
                  <div class="category-item">
                    <img src={item?.categoryImage || ""} alt="img" />
                    <div class="text">
                      <h6>{item?.categoryName || "#N/A"}</h6>
                      <span>
                        {item?.count || 0} item{item?.count > 1 ? "s" : ""}
                      </span>
                    </div>
                  </div>
                ))}
              </>
            ) : (
              <NoRecord />
            )}
            {/* <div class="category-item">
              <img src="/assets/img/browse-category-1.png" />
              <div class="text">
                <h6>Mobile Devices</h6>
                <span>5,000 items</span>
              </div>
            </div> */}
          </div>

          <hr class="ct_border_bottom" />
        </div>
      </section>

      <section class="ct_mt_60 mb-5 pb-5">
        <div class="container">
          <div class="row">
            <div class="col-md-12">
              <div class="d-flex align-items-center justify-content-between mb-2">
                <div>
                  <h5 class="ct_fs_32 ct_fw_600">Featured Assets</h5>
                  <p class="mb-0 ct_text_clr_4B5563">
                    Premium assets available for acquisition
                  </p>
                </div>
                <a
                  onClick={(e) => {
                    e.preventDefault();
                    navigate(webPaths?.AllAssets);
                  }}
                  class="ct_text_clr_4B5563 ct_fw_600 ct_cursor_pointer"
                >
                  View More <i class="fa-solid fa-angle-right ms-1"></i>
                </a>
              </div>
            </div>
          </div>
          <div className="ct_assets_data ct_custom_scroll pb-4">
            <div class="row mt-3">
              {assetList?.length > 0 ? (
                assetList?.map((item, index) => (
                  <AssetCard
                    data={
                      item
                      //   {
                      //   promote: 1,
                      //   AssetImages: [
                      //     { image_url: "/assets/img/assets_1.png" },
                      //   ],
                      //   id: index + 1,
                      //   latitude: "",
                      //   longitude: "",
                      //   lock: index % 2 == 0 ? 1 : 0,
                      //   UIC: "6568520",
                      //   AssetName: "iPhone 15",
                      //   isStolen: index % 2 == 0 ? true : false,
                      //   AssetDetails:
                      //     "This property is not available for sale. Kindly...",
                      // }
                    }
                  />
                ))
              ) : (
                <NoRecord />
              )}
            </div>
          </div>
        </div>
      </section>
    </PanelLayout>
  );
};

export default Home;
